<template>
  <div>
    <toolbarTitle
      :title="invoice.fortnoxNumber ? 'Invoice Info #' + invoice.fortnoxNumber : 'Invoice Info'"
      class="mb-2"
      :titleRed="`(` + statusList.find((item) => item.id === invoice.status).label + `)`" />
    <div class="elevation-1 rounded">
      <v-card v-if="invoice" class="pa-4">
        <v-row>
          <v-col class="py-0" style="min-width: 250px">
            <v-card-title class="accent--text medium">
              <span class="text-body-2 font-weight-bold">Company Name</span>
            </v-card-title>
            <v-card-subtitle class="font-weight-bold pb-0">
              <v-icon @click="handleCompanyDialog" color="primary" class="pa-1" small> mdi-domain </v-icon>
              {{ invoice.company.name ? invoice.company.name : "---" }}</v-card-subtitle
            >
          </v-col>
          <v-col class="py-0" style="min-width: 250px">
            <v-card-title class="accent--text medium">
              <span class="text-body-2 font-weight-bold">Customer</span>
            </v-card-title>
            <v-card-subtitle v-if="invoice.customer" class="font-weight-bold pb-0">
              <v-tooltip color="black" bottom style="cursor: pointer">
                <template v-slot:activator="{ on, attrs }">
                  <b v-bind="attrs" v-on="on"
                    >{{
                      invoice.customer.companyCustomerNumber
                        ? "IATA Number " + invoice.customer.companyCustomerNumber
                        : ""
                    }}
                    {{ invoice.customer.firstName }}
                    {{ invoice.customer.lastName }}
                  </b>
                  <div class="text-body-2">
                    {{ invoice.customer.email }}
                  </div>
                </template>
                <div>
                  {{ invoice.customer.email }}
                </div>
              </v-tooltip>
            </v-card-subtitle>
            <v-card-subtitle v-else class="font-weight-bold">
              <v-tooltip color="black" bottom style="cursor: pointer">
                <template v-slot:activator="{ on, attrs }">
                  <b v-bind="attrs" v-on="on"
                    >{{ invoice.order.customer.firstName }} {{ invoice.order.customer.lastName }}</b
                  >
                </template>
                <div>
                  {{ invoice.order.customer.email }}
                </div>
              </v-tooltip>
            </v-card-subtitle>
          </v-col>
          <v-col class="py-0" style="min-width: 250px">
            <v-card-title class="accent--text medium">
              <span class="text-body-2 font-weight-bold"> Order Debited (GMT +{{ gmt }})</span>
            </v-card-title>
            <v-card-subtitle class="font-weight-bold pb-0">
              {{ invoice.created | localizeUTCAndGetDate }}
              <v-icon small class="third--text clock mb-1">mdi-clock-time-eight-outline</v-icon>
              {{ invoice.created | localizeUTCAndGetTime }}
              <div v-if="invoice.debitedBy" class="text-body-2">
                by {{ invoice.debitedBy ? invoice.debitedBy.fullName ?? invoice.debitedBy.name : "" }}
              </div>
            </v-card-subtitle>
          </v-col>
          <v-col class="py-0" style="min-width: 250px">
            <v-card-title class="accent--text medium">
              <span class="text-body-2 font-weight-bold"> Must be Paid Before</span>
            </v-card-title>
            <v-card-subtitle class="font-weight-bold" v-if="invoice.invoicedInExternalSystem">{{
              invoice.invoicedInExternalSystem | localizeUTCAddDaysAndGetDate(invoice.company.allowedDaysToPay)
            }}</v-card-subtitle>
            <v-card-subtitle class="font-weight-bold" v-else> Not invoiced yet </v-card-subtitle>
          </v-col>
        </v-row>
        <v-row>
          <v-col class="py-0" style="min-width: 250px">
            <v-card-title class="accent--text medium">
              <span class="text-body-2 font-weight-bold"> Total Price</span>
            </v-card-title>
            <v-card-subtitle class="font-weight-bold">{{ invoice.totalTransactionPrice.plainText }}</v-card-subtitle>
          </v-col>
          <v-col class="py-0" style="min-width: 250px">
            <v-card-title class="accent--text medium">
              <span class="text-body-2 font-weight-bold"> Reference</span>
            </v-card-title>
            <v-card-subtitle class="font-weight-bold">{{
              invoice.reference ? invoice.reference : "-"
            }}</v-card-subtitle>
          </v-col>
          <v-col class="py-0" style="min-width: 250px">
            <v-card-title class="accent--text medium">
              <span class="text-body-2 font-weight-bold"> OCR Number</span>
            </v-card-title>
            <v-card-subtitle class="font-weight-bold">{{
              invoice.ocrNumber ? invoice.ocrNumber : "-"
            }}</v-card-subtitle>
          </v-col>
          <v-col class="py-0" style="min-width: 250px">
            <v-card-title class="accent--text medium">
              <span class="text-body-2 font-weight-bold"> Invoice Events </span>
            </v-card-title>
            <v-card-subtitle class="font-weight-bold">
              <v-tooltip color="black" bottom style="cursor: pointer">
                <template v-slot:activator="{ on, attrs }">
                  <div
                    class="font-weight-medium one-line threeDots d-flex align-center"
                    style="max-width: 250px"
                    v-bind="attrs"
                    v-on="on">
                    <v-icon small @click="eventDetail = invoice" color="primary" class="mr-1">mdi-history</v-icon>
                    <span class="text-truncate">
                      {{ lastEvent(invoice.events[0]).description }}
                    </span>
                  </div>
                </template>
                <div>{{ lastEvent(invoice.events[0]).description }}</div>
              </v-tooltip>
            </v-card-subtitle>
          </v-col>
        </v-row>
        <v-col v-if="invoice.comment" class="comment-col">
          <v-card class="comment-card">
            <v-card-title class="medium comment-title">
              <span class="text-body-2 font-weight-bold"> Comment </span>
            </v-card-title>
            <v-card-subtitle class="medium comment-subtitle">
              <span>
                {{ invoice.comment }}
              </span>
            </v-card-subtitle>
          </v-card>
        </v-col>
      </v-card>
    </div>

    <v-dialog
      v-model="detailDialog"
      :loading="isLoading"
      width="1000px"
      class="pa-5"
      @click:outside="detailDialog = false">
      <v-card>
        <v-toolbar fixed color="titlebg" class="title" dense dark>
          <v-toolbar-title class="ml-2">Company : {{ companyDetail.name }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="detailDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>

        <companyDetail v-if="invoice.company" :company="companyDetail" :loading="isLoading" />
      </v-card>
    </v-dialog>
    <v-dialog v-if="eventDetail" v-model="eventDetail" @click:outside="eventDetail = false" max-width="700px">
      <v-card>
        <v-toolbar fixed color="titlebg" class="title" dense dark>
          <v-toolbar-title>Invoice Events History</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="eventDetail = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <div class="px-4 py-4">
          <v-row>
            <v-col>
              <v-card-text style="max-height: 500px; overflow: auto" class="py-0 elevation-2 rounded-lg">
                <v-timeline align-top dense>
                  <v-timeline-item v-for="(event, index) in eventDetail.events" :key="index" small>
                    <v-row class="pt-1">
                      <v-col cols="3">
                        <strong>{{ event.datetime }}</strong>
                      </v-col>
                      <v-col>
                        <strong>{{ event.user.fullName ?? event.user.name }}</strong>
                        <div class="text-caption">
                          {{ event.description }}
                        </div>
                      </v-col>
                    </v-row>
                  </v-timeline-item>
                </v-timeline>
              </v-card-text>
            </v-col>
          </v-row>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { getErrorMessage } from "@/util/helpers";
import moment from "moment";
import companyDetail from "@/components/info/companyDetail";
import toolbarTitle from "@/components/common/toolbarTitle";
import Trainplanet from "@/util/trainplanet.api";

export default {
  components: {
    toolbarTitle,
    companyDetail,
  },
  props: {
    invoice: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    gmt: null,
    isLoading: false,
    eventDetail: false,
    customers: [],
    detailDialog: false,
    statusList: [
      {
        label: "Pending",
        id: -1,
      },
      {
        label: "Pending",
        id: 0,
      },
      {
        label: "Invoiced",
        id: 1,
      },
      {
        label: "Paid",
        id: 2,
      },
      {
        label: "Accounted",
        id: 3,
      },
    ],
  }),
  computed: {
    companyDetail() {
      return { ...this.invoice.company, customers: this.customers };
    },
  },
  mounted() {
    this.gmt = moment().utcOffset() / 60;
  },
  methods: {
    async initCustomersByCompanyId(companyId) {
      try {
        this.isLoading = true;
        this.customers = [];
        const res = await Trainplanet.getCustomerList({ companyId });
        this.customers = res.customers;
      } catch (error) {
        await this.$store.dispatch("error", getErrorMessage(error));
      } finally {
        this.isLoading = false;
      }
    },

    async handleCompanyDialog() {
      this.detailDialog = true;
      await this.initCustomersByCompanyId(this.invoice.company.id);
    },

    lastEvent(event) {
      let description;
      if (event !== undefined) {
        //some inquiry might does not have those info so always check
        if (event.description !== undefined) description = event.description;
      }
      return {
        description: description,
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.comment-col {
  padding: 16px !important;
}

.comment-card {
  background-color: rgb(255, 246, 217);
  padding: 12px 16px;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.comment-title,
.comment-subtitle {
  padding: 0 !important;
}
</style>
